module.exports = __webpack_public_path__ + "332e8e6e61fc009fb321a11b8f8844b1.svg";